// src/api/useSignUp.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/api";

const fetchCreateAssignment = ({ data, agendaId }) => {
  return api.post(`/assignment/${agendaId}`, data);
};

/**
 * 회원가입 요청을 위한 useMutation 훅을 사용하는 커스텀 훅
 */
export const useSubmitAssignmentQuery = () => {
  return useMutation({
    mutationFn: fetchCreateAssignment,
  });

  // return { mutate, isPending, isError, data, error };
};
